/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum EdgeStatus {
    TO_CHECK = 'to_check',
    REJECTED = 'rejected',
    VALIDATED = 'validated',
}
